<template>
<div   v-loading="exportLoading"
       element-loading-text="正在更新"
        >
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form>
        <el-form-item>
            <el-button  type="primary" @click="exportTable()">批量数据开关</el-button>
             <el-radio v-model="status" label="1">数据恢复</el-radio>
            <el-radio v-model="status" label="2">数据关停</el-radio>
        </el-form-item>
    </el-form>
</el-col>
 
    <el-input
    type="textarea"
    :rows="20"
    placeholder="请粘贴要导出的卡号列表(每一条一行)"
    v-model="textarea" class="textexport">
    </el-input>
</div>
</template>
<script>
import {bathdataStateUp} from '../../api/api'
export default {
  data() {
    return {
      isUpload:true,
      url:'',
      textarea: '',
      exportLoading:false,
      status:"1"
    }

    },methods:{
         exportTable(){

             if(this.textarea.trim()==""){
                 this.$message({
                            message: '卡信息不能为空',
                            type: 'error'
                        });
             }else{
            let strs="";
            if(this.status=="1"){
                strs='确定要进行批量数据恢复吗, 是否继续?';
            }else{
                    strs='确定要进行批量数据关停吗, 是否继续?';
            }
        this.$confirm(strs, '确认提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                        let para={
                            cardinfo:this.textarea.trim(),
                            status:this.status
                        }
                        this.exportLoading=true;
                        bathdataStateUp(para).then((res) => {
                            if(res.code==0){
                                this.url=res.data;
                                this.isUpload=true;
                                this.exportLoading=false;
                                this.textarea=res.msg;
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                                this.exportLoading=false;
                                this.isUpload=false;
                            }
                        });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
                });
             }
      }
  }

}
</script>  
<style>
    .textexport{
        margin-top:10px;
        font-size:18px;
    }
</style>



// WEBPACK FOOTER //
// bathdataupdate.vue?3fe5cbad